import { createApiClient } from '@wix/premium-fed-sdk/@apis-infra-react';
import { PremiumCartServerlessApiConfig } from './api-configs/premium-cart-serverless.api-config';
export const PremiumCartServerlessApiClient = createApiClient(PremiumCartServerlessApiConfig);
//# sourceMappingURL=premium-cart-serverless.api-client.js.map